import JSEncrypt from "jsencrypt/bin/jsencrypt";

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQClSu1AHKGRljlFOf3WK3r+MtOiuzEqwY07lQ9/NmOT//puabqkyb5gOFitPHqEJiUPofywNepIROM2xlt77E1/RRofYPJzlV7w+BhlhhNn0iS48k/9Jpo3yUboF/QhVM9Bj8LVKJ9G7T87WGppFnQmDMNQlUlLjzcxAFI0mWUWlQIDAQAB";

const privateKey =
  "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAKVK7UAcoZGWOUU5/dYrev4y06K7MSrBjTuVD382Y5P/+m5puqTJvmA4WK08eoQmJQ+h/LA16khE4zbGW3vsTX9FGh9g8nOVXvD4GGWGE2fSJLjyT/0mmjfJRugX9CFUz0GPwtUon0btPztYamkWdCYMw1CVSUuPNzEAUjSZZRaVAgMBAAECgYAvNtfOGF+OVnrFa2s2YfUf5yTMtuu0atUMz+c9TyviepvuLgVCTN40XeP2l+/nD35GmN609rGVMxgz7TT0kOsRmd3BSTpCLjxQb9XQahK8e3GwxdUE1GBP8ttIxwksQGGg9hiPYdz21DGTODYLghrEkbVF4SkqZlLp5ZOQ4JgUAQJBANjDKpOi3/TvJ8j0EQWo1kUaCgNCMUGhrkdzzVKdbdPeNdiVo/XepajVXdSNlx6Xn6bpRFToL1QTbhSW95Yl39kCQQDDNqO/zlOetPInLfQ6yzClWpkrXUuMEPvl4gr8O05JLPrDFJx8+g5vLx/lwoNOa/gBSVCmIs/gJ3phe3pwhrMdAkEAjpr3q+F/zbh5SC+p8zs8nIGhDLvDhBZGfiOldTC1TKnoavEnyV4NRqH49RmhzjKaikj095c5a+rMhSc9A78vIQJAN74wgCLQqe8NfraWmPtQhscaGdHoMrTe2UP00xW0Qxz+9hm6nc1htcoFF7y1df1KskNXLjmelmlvfsqdqegs2QJBAKjDtsUvMg7KRaTZrncxM2L8pt311FzkX4L3e7xkIYJ8T2qU3nyRVmrQYI3TtxTGc/VXeUbeD8F2NnowG2eSqrs=";

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey); // 设置公钥
  return encryptor.encrypt(txt); // 对需要加密的数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPrivateKey(privateKey);
  return encryptor.decrypt(txt);
}
